require('../../modules/es6.array.fill');
module.exports = require('../../modules/_core').Array.fill;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/fn/array/fill.js
// module id = 337
// module chunks = 0